import {
  http,
  HttpResponse,
  RestRequest,
  RestContext,
  ResponseFunction,
} from 'msw'
import { takeDroppedResponse } from '../modules/droppedResponse'
import { handlers as accountHandlers } from './accounts'
import { handlers as accountDocumentsHandlers } from './accountDocuments'
import { handlers as callHandlers } from './calls'
import { handlers as casesHandlers } from './cases'
import { handlers as caseNotesHandlers } from './caseNotes'
import { handlers as caseDocumentsHandlers } from './caseDocuments'
import { handlers as caseTypeHandlers } from './selectLists/caseTypes'
import { handlers as serviceRequestsHandlers } from './serviceRequests'
import { handlers as serviceRequestNotesHandlers } from './serviceRequestNotes'
import { handlers as serviceRequestDocumentsHandlers } from './serviceRequestDocuments'
import { handlers as serviceRequestTypeHandlers } from './selectLists/serviceRequestTypes'
import { handlers as contactsHandlers } from './contacts'
import { handlers as contractsHandlers } from './contracts'
import { handlers as contractDocumentsHandlers } from './contractDocuments'
import { handlers as companyHandlers } from './companies'
import { handlers as companyDocumentsHandlers } from './companyDocuments'
import { handlers as companyMSDocumentsHandlers } from './companyMSDocuments'
import { handlers as companyMSServiceDocumentHandlers } from './companyMSServiceDocuments'
import { handlers as companyContactHandlers } from './companyContacts'
import { handlers as companyContactRoleHandlers } from './selectLists/companyContactRoles'
import { handlers as companyLastSelectedStateHandlers } from './companyLastSelectedStates'
import { handlers as companyMasterServiceHandlers } from './companyMasterServices'
import { handlers as companyMSContactHandlers } from './companyMSContacts'
import { handlers as companyMSServiceHandlers } from './companyMSServices'
import { handlers as companyMSTeamMemberHandlers } from './companyMSTeamMembers'
import { handlers as companyTeamMemberHandlers } from './companyTeamMembers'
import { handlers as countryHandlers } from './selectLists/countries'
import { handlers as entityActionsHandlers } from './entityActions'
import { handlers as emailHandlers } from './emails'
import { handlers as feedbackHandlers } from './feedback'
import { handlers as fieldSetHandlers } from './fieldSets'
import { handlers as fieldSetFieldHandlers } from './fieldSetFields'
import { handlers as groupHandlers } from './groups'
import { handlers as industryHandlers } from './selectLists/industries'
import { handlers as leadSourceCampaignHandlers } from './selectLists/leadSourceCampaigns'
import { handlers as leadSourceContactHandlers } from './selectLists/leadSourceContacts'
import { handlers as leadSourceEventHandlers } from './selectLists/leadSourceEvents'
import { handlers as locationHandlers } from './locations'
import { handlers as locationDocumentsHandlers } from './locationDocuments'
import { handlers as locationHardwareCompanyOwnedItemsHandlers } from './locationHardwareCompanyOwnedItems'
import { handlers as locationHardwareTenantOwnedItemsHandlers } from './locationHardwareTenantOwnedItems'
import { handlers as locationCompanyContactHandlers } from './locationCompanyContacts'
import { handlers as locationTypeHandlers } from './selectLists/locationTypes'
import { handlers as meetingsHandlers } from './meetings'
import { handlers as ordersHandlers } from './orders'
import { handlers as orderLastSelectedStateHandlers } from './orderLastSelectedStates'
import { handlers as orderMasterServicesHandlers } from './orderMasterServices'
import { handlers as orderMSServicesHandlers } from './orderMSServices'
import { handlers as orderTeamMembersHandlers } from './orderTeamMembers'
import { handlers as orderMSTeamMembersHandlers } from './orderMSTeamMembers'
import { handlers as orderContactsHandlers } from './orderContacts'
import { handlers as orderMSContactsHandlers } from './orderMSContacts'
import { handlers as orderDocumentsHandlers } from './orderDocuments'
import { handlers as orderMSDocumentsHandlers } from './orderMSDocuments'
import { handlers as orderMSServiceDocumentHandlers } from './orderMSServiceDocuments'
import { handlers as opportunitiesHandlers } from './opportunities'
import { handlers as opportunityDocumentsHandlers } from './opportunityDocuments'
import { handlers as opportunityMSDocumentsHandlers } from './opportunityMSDocuments'
import { handlers as opportunityLastSelectedStateHandlers } from './opportunityLastSelectedStates'
import { handlers as opportunityMasterServicesHandlers } from './opportunityMasterServices'
import { handlers as opportunityMSServicesHandlers } from './opportunityMSServices'
import { handlers as opportunityMSServiceDocumentHandlers } from './opportunityMSServiceDocuments'
import { handlers as opportunityNotesHandlers } from './opportunityNotes'
import { handlers as opportunityMSNotesHandlers } from './opportunityMSNotes'
import { handlers as opportunityMSServiceNotesHandlers } from './opportunityMSServiceNotes'
import { handlers as companyNotesHandlers } from './companyNotes'
import { handlers as companyMSNotesHandlers } from './companyMSNotes'
import { handlers as companyMSServiceNotesHandlers } from './companyMSServiceNotes'
import { handlers as orderNotesHandlers } from './orderNotes'
import { handlers as orderMSNotesHandlers } from './orderMSNotes'
import { handlers as orderMSServiceNotesHandlers } from './orderMSServiceNotes'
import { handlers as locationNotesHandlers } from './locationNotes'
import { handlers as supplierNotesHandlers } from './supplierNotes'
import { handlers as supplierProductNotesHandlers } from './supplierProductNotes'
import { handlers as tsdNotesHandlers } from './tsdNotes'
import { handlers as accountNotesHandlers } from './accountNotes'
import { handlers as contractNotesHandlers } from './contractNotes'
import { handlers as opportunityRegistrationHandlers } from './opportunityRegistrations'
import { handlers as opportunityTeamMembersHandlers } from './opportunityTeamMembers'
import { handlers as opportunityMSTeamMembersHandlers } from './opportunityMSTeamMembers'
import { handlers as opportunityContactsHandlers } from './opportunityContacts'
import { handlers as opportunityMSContactsHandlers } from './opportunityMSContacts'
import { handlers as opportunityStageHandlers } from './selectLists/opportunityStages'
import { handlers as orderServiceOrderHandlers } from './orderServiceOrders'
import { handlers as personHandlers } from './persons'
import { handlers as projectsHandlers } from './projects'
import { handlers as productHandlers } from './products'
import { handlers as productCategoryHandlers } from './productCategories'
import { handlers as productGroupHandlers } from './productGroups'
import { handlers as productSubcategoryHandlers } from './productSubcategories'
import { handlers as productKitHandlers } from './productKitItems'
import { handlers as subindsutryHandlers } from './selectLists/subindustries'
// Third-party, not our API: an absolute URL rather than an /api path. See the
// note in ./smarty/index.ts for why it must be mocked at all.
import { handlers as smartyHandlers } from './smarty'
import { handlers as suppliersHandlers } from './suppliers'
import { handlers as supplierLastSelectedStateHandlers } from './supplierLastSelectedStates'
import { handlers as supplierContactHandlers } from './supplierContacts'
import { handlers as supplierContactRoleHandlers } from './selectLists/supplierContactRoles'
import { handlers as supplierProductHandlers } from './supplierProducts'
import { handlers as supplierProductItemHandlers } from './supplierProductItems'
import { handlers as supplierDocumentsHandlers } from './supplierDocuments'
import { handlers as supplierProductDocumentsHandlers } from './supplierProductDocuments'
import { handlers as supplierResources } from './supplierResources'
import { handlers as taskHandlers } from './tasks'
import { handlers as teamMemberHandlers } from './teamMembers'
import { handlers as teamMemberLastSelectedStateHandlers } from './teamMemberLastSelectedStates'
import { handlers as tsdHandlers } from './tsds'
import { handlers as tsdContactHandlers } from './tsdContacts'
import { handlers as tsdContactRoleHandlers } from './selectLists/tsdContactRoles'
import { handlers as tsdDocumentsHandlers } from './tsdDocuments'
import { handlers as tsdSupplierHandlers } from './tsdSuppliers'
import { handlers as TsdResourceHandlers } from './tsdResources'
import { handlers as userHandlers } from './users'
import { handlers as passkeyHandlers } from './passkeys'
import { handlers as operationHandlers } from './operations'
import { logMockRequest, MSWRequestHandler } from '~/api/msw/decorators'
import { adaptV1Handler } from '~/api/msw/mswCompat'

async function getApi200(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log('Mock handler getApi invoked.')
  const responseBody = {
    self: { path: '/api', method: 'GET' },
    version_id: 'source version',
    login: { path: '/api/users/authentication', method: 'POST' },
  }

  return res(ctx.status(200), ctx.json(responseBody))
}

async function getApi500(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log('Mock handler getApi500 invoked.')
  const responseBody = {}
  return res(ctx.status(500), ctx.json(responseBody))
}

const getApi = getApi200

const apiHandlers = [{ method: 'get', path: '/api', handler: getApi }]

interface HandlerConfig {
  method: string
  path: string
  handler: MSWRequestHandler
}

function makeURL(path: string, baseUrl: string) {
  // base is hard-coded here.  It should be read from runtimeConfig.public.serverOrigin,
  // but useRuntimeConfig isn't easily available until the project moves all the way to nuxt 3.
  // This really matters should we want to use API mocking in a release stage other than development.

  return `${path}`
}

function makeHandler(h: HandlerConfig, baseUrl: string) {
  const resolver = adaptV1Handler(logMockRequest(h.handler))
  return http[h.method.toLowerCase() as keyof typeof http](
    makeURL(h.path, baseUrl),
    async (info) => {
      const response = await resolver(info)
      // The handler HAS run (a write is stored); only its answer is lost. An
      // e2e hook — see modules/droppedResponse.ts.
      return takeDroppedResponse(info.request) ? HttpResponse.error() : response
    }
  )
}

export function handlers(baseUrl = 'http://127.0.0.1:3000') {
  return [
    apiHandlers,
    accountHandlers,
    accountDocumentsHandlers,
    callHandlers,
    casesHandlers,
    caseNotesHandlers,
    caseDocumentsHandlers,
    caseTypeHandlers,
    serviceRequestsHandlers,
    serviceRequestNotesHandlers,
    serviceRequestDocumentsHandlers,
    serviceRequestTypeHandlers,
    contactsHandlers,
    contractsHandlers,
    contractDocumentsHandlers,
    companyHandlers,
    companyContactHandlers,
    companyContactRoleHandlers,
    companyLastSelectedStateHandlers,
    companyMasterServiceHandlers,
    companyMSContactHandlers,
    companyMSServiceHandlers,
    companyMSTeamMemberHandlers,
    companyTeamMemberHandlers,
    companyDocumentsHandlers,
    countryHandlers,
    companyMSDocumentsHandlers,
    companyMSServiceDocumentHandlers,
    entityActionsHandlers,
    emailHandlers,
    feedbackHandlers,
    fieldSetHandlers,
    fieldSetFieldHandlers,
    groupHandlers,
    industryHandlers,
    leadSourceCampaignHandlers,
    leadSourceContactHandlers,
    leadSourceEventHandlers,
    locationHandlers,
    locationDocumentsHandlers,
    locationHardwareCompanyOwnedItemsHandlers,
    locationHardwareTenantOwnedItemsHandlers,
    locationCompanyContactHandlers,
    locationTypeHandlers,
    ordersHandlers,
    orderMasterServicesHandlers,
    orderMSServicesHandlers,
    orderLastSelectedStateHandlers,
    orderTeamMembersHandlers,
    orderMSTeamMembersHandlers,
    orderContactsHandlers,
    orderMSContactsHandlers,
    orderDocumentsHandlers,
    orderMSDocumentsHandlers,
    orderMSServiceDocumentHandlers,
    meetingsHandlers,
    opportunitiesHandlers,
    opportunityDocumentsHandlers,
    opportunityMSDocumentsHandlers,
    opportunityNotesHandlers,
    opportunityMSNotesHandlers,
    opportunityMSServiceNotesHandlers,
    companyNotesHandlers,
    companyMSNotesHandlers,
    companyMSServiceNotesHandlers,
    orderNotesHandlers,
    orderMSNotesHandlers,
    orderMSServiceNotesHandlers,
    locationNotesHandlers,
    supplierNotesHandlers,
    supplierProductNotesHandlers,
    tsdNotesHandlers,
    accountNotesHandlers,
    contractNotesHandlers,
    opportunityLastSelectedStateHandlers,
    opportunityMasterServicesHandlers,
    opportunityMSServicesHandlers,
    opportunityMSServiceDocumentHandlers,
    opportunityRegistrationHandlers,
    opportunityTeamMembersHandlers,
    opportunityMSTeamMembersHandlers,
    opportunityContactsHandlers,
    opportunityMSContactsHandlers,
    opportunityStageHandlers,
    orderServiceOrderHandlers,
    personHandlers,
    projectsHandlers,
    productHandlers,
    productCategoryHandlers,
    productGroupHandlers,
    productSubcategoryHandlers,
    productKitHandlers,
    subindsutryHandlers,
    suppliersHandlers,
    supplierLastSelectedStateHandlers,
    supplierContactHandlers,
    supplierContactRoleHandlers,
    supplierProductHandlers,
    supplierProductItemHandlers,
    supplierDocumentsHandlers,
    supplierProductDocumentsHandlers,
    supplierResources,
    taskHandlers,
    teamMemberHandlers,
    teamMemberLastSelectedStateHandlers,
    tsdHandlers,
    tsdContactHandlers,
    tsdContactRoleHandlers,
    tsdDocumentsHandlers,
    tsdSupplierHandlers,
    TsdResourceHandlers,
    userHandlers,
    passkeyHandlers,
    operationHandlers,
    smartyHandlers,
  ]
    .flat()
    .map((h) => makeHandler(h, baseUrl))
}
